export default "__VITE_PUBLIC_ASSET__b2f1e259__"